import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";
import { RefObject } from "react";

import { Switch } from "@/components/Form/Base/switch.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type FeatureSwitchComponentProps = {
    isOpen: boolean;
    features: Array<{
        name: FeatureToggleKey;
        value: boolean;
        serverValue: boolean | null;
    }>;
    ref: RefObject<HTMLDivElement | null>;
    onToggle: (state?: boolean) => void;
    onToggleFeature: (name: FeatureToggleKey, value: boolean) => void;
};

const FeatureSwitchComponent = ({
    isOpen,
    features,
    ref,
    onToggleFeature
}: FeatureSwitchComponentProps) => {
    const { t } = useGranite();

    return (
        <div
            className={cn(
                "tw:fixed tw:left-4 tw:bottom-16 tw:border tw:border-grey-input tw:bg-white tw:p-2 tw:pt-3 tw:rounded-md tw:w-[calc(100vw-4rem)] tw:flex-col tw:flex tw:gap-2",
                {
                    "tw:hidden": !isOpen,
                    "tw:visible": isOpen
                }
            )}
            ref={ref}
        >
            {features.map((feature) => {
                return (
                    <div
                        key={feature.name}
                        className={cn(
                            "tw:flex tw:items-center tw:justify-between tw:gap-4"
                        )}
                    >
                        <Switch
                            name={feature.name}
                            value={feature.value}
                            label={t(`featureSwitch.${feature.name}`)}
                            onToggle={() =>
                                onToggleFeature(feature.name, !feature.value)
                            }
                        />
                        {isDefined(feature.serverValue) && (
                            <div
                                className={cn(
                                    "tw:flex tw:items-center tw:gap-2"
                                )}
                            >
                                <span className={cn("tw:block")}>
                                    Server value
                                </span>
                                <span
                                    className={cn(
                                        "tw:max-w-12.5 tw:text-white tw:rounded-sm tw:text-sm tw:px-1",
                                        {
                                            "bg-success": feature.serverValue,
                                            "bg-danger": !feature.serverValue
                                        }
                                    )}
                                >
                                    {String(feature.serverValue)}
                                </span>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export { FeatureSwitchComponent };
